<template>
  <div>
    <vs-popup
      fullscreen
      :title="$t('GenericProducts')"
      :active.sync="showModal"
      id="deduction-generic-popup"
    >
      <form>
        <loading v-if="showLoading"></loading>
        <div v-else class="vx-row mb-6">
          <div class="vx-col md:w-1/2 w-full">
            <label class="vs-select--label datepicker-lb">{{
              $t("GenericProduct")
            }}</label>
            <treeselect
              ref="genericProduct"
              v-model="genericProduct"
              label="name"
              name="genericproduct"
              :multiple="false"
              placeholder=""
              :async="true"
              :load-options="loadOptionsGenericProduct"
              @select="onSelectedGenericProduct"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('genericproduct')"
              >{{ errors.first("genericproduct") }}</span
            >
          </div>
          <div class="vx-col md:w-1/6 w-full mt-4">
            <vs-button
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-plus"
              @click.prevent="addGenericProductToList()"
              >{{ $t("AddToList") }}</vs-button
            >
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <div class="vx-col w-full">
              <vs-button
                @click="uploadFile()"
                class="bg_m_green float-right mt-4"
                v-if="fileUploaded"
                :disabled="disabledBtn"
              >
                <feather-icon
                  icon="PlusIcon"
                  svgClasses="h-4 w-4"
                  class="ico"
                />
                {{ $t("Submit") }}
              </vs-button>
              <label class="custom-file-upload mt-4 float-right">
                <input
                  type="file"
                  id="file"
                  ref="file"
                  v-on:change="handleFileUpload()"
                />
                <feather-icon
                  icon="PaperclipIcon"
                  svgClasses="h-4 w-4"
                  class="ico"
                />
                {{ $t("AddGenericProductsListViaExcel") }}
                <span v-if="uploadedFileName" class="file-name">{{
                  uploadedFileName
                }}</span>
              </label>
            </div>
          </div>
        </div>
      </form>
      <vs-table :data="listGenericProduct" ref="table" class="custom-tbl">
        <template slot="thead">
          <th>#</th>
          <th>{{ $t("GenericProductName") }}</th>
          <th>{{ $t("Action") }}</th>
        </template>

        <template>
          <vs-tr :key="i" v-for="(GenericProduct, i) in listGenericProduct">
            <vs-td>
              {{ i + 1 }}
            </vs-td>
            <vs-td>
              {{ GenericProduct.genericProductName }}
            </vs-td>
            <vs-td>
              <vs-button
                radius
                color="danger"
                size="small"
                type="gradient"
                icon-pack="feather"
                icon="icon-x"
                @click.prevent="unassignGenericProduct(i)"
                class="d-inline"
              ></vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <!-- <div class="vx-row">
        <div class="vx-col w-full mt-5 flex">
          
          <manual-pagination
            :totalCount="totalCount"
            v-if="pageCount > 1"
            @renderPage="renderPage"
            class="flex-auto"
          ></manual-pagination>
        </div>
      </div> -->
      <!-- <div class="vx-col lg:w-1/5 w-full flex"> -->
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="filled"
            icon-pack="feather"
            class="float-right mt-6"
            @click.prevent="assignGenericProduct()"
            >{{ $t("Save") }}</vs-button
          >
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<style lang="scss">
#deduction-generic-popup .vs-popup--content {
  height: 100%;
}
.view-details {
  padding: 0.1rem 0.75rem !important;
  display: inline-block;
  margin: 0.4rem 0 0.2rem 0;
}
.view-details i {
  padding-left: 0.2rem;
  position: relative;
  top: 2px;
  display: inline-block;
}
input[type="file"] {
  display: none;
}

.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 4px 12px 4px 12px;
  cursor: pointer;
  float: left;
}

.bg_m_green {
  border-radius: 6px 0 0 6px !important;
  padding: 0.3rem 0.8rem !important;
}

.file-name {
  padding: 0 0.5rem;
  background-color: #eeeff1;
  position: relative;
  left: -0.65rem;
}
</style>
<script>
import { mapActions } from "vuex";
import Loading from "@/components/loading/Loading.vue";
import { Validator } from "vee-validate";
import Treeselect from "@/components/CustomTreeSelect.vue";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
const dict = {
  custom: {
    genericproduct: {
      required: "لطفا دسته  را انتخاب نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "saleManagement_Contract_Management_GenericProductPopup",

  props: {
    show: { default: false },
    genericProductModel: {
      default: {},
    },
    keywords: {},
  },
  data() {
    return {
      // totalCount: 0,
      // pageCount: 0,
      dataCurrent: {},
      showLoading: false,
      listGenericProduct: [],
      genericProductInfo: {
        id: null,
        genericProductsId: [],
      },
      genericProductId: null,
      genericProduct: null,
      file: "",
      fileUploaded: false,
      disabledBtn: false,
      uploadedFileName: "",
      emptyFileInRefs: "",
    };
  },
  mounted() {
    this.emptyFileInRefs = this.$refs.file.files;
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      assignGenericProductInfo: "deductionAndIncrease/assignGenericProductInfo",
      fetchGenericProducts: "genericProduct/fetchFullSearch",
      getListGenericProduct: "genericProduct/listGenericProductPerContract",
      importExcelGenericProduct: "excel/importExcelGenericProduct",
    }),
    addGenericProductToList() {
      this.listGenericProduct.push({
        genericProductId: this.dataCurrent.id,
        genericProductName: this.dataCurrent.label,
        itemCode: this.dataCurrent.itemCode,
      });
    },
    onSelectedGenericProduct(data) {
      this.dataCurrent = {};
      this.dataCurrent = data;
    },
    loadOptionsGenericProduct({ action, searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          if (action === ASYNC_SEARCH) {
            var justGenericProductName = "name=" + searchQuery;
            this.fetchGenericProducts(justGenericProductName).then((r) => {
              const options = [];
              r.data.forEach(function (element) {
                options.push({
                  id: element.id,
                  label: element.name,
                  itemCode: element.itemCode,
                });
              });
              callback(null, options);
            });
          }
        }
      }, 2000);
    },
    assignGenericProduct() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          var listGenericId = [];
          this.genericProductInfo.id =
            this.genericProductModel.deductionAndIncreaseId;
          this.listGenericProduct.forEach(function (element) {
            listGenericId.push(element.genericProductId);
          });
          this.genericProductInfo.genericProductsId = listGenericId;
          this.assignGenericProductInfo(this.genericProductInfo).then(() => {
            this.$vs.notify({
              title: "عملیات موفق",
              text: "دسته مورد نظر با موفقیت اضافه شد!",
              color: "success",
            });
            this.$validator.reset();
          });
        }
      });
    },
    unassignGenericProduct(index) {
      this.listGenericProduct.splice(index, 1);
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.uploadedFileName = this.file.name;
      this.fileUploaded = true;
    },
    removeUploadFile() {
      this.file = "";
      this.$refs.file.files = this.emptyFileInRefs;
      this.uploadedFileName = "";
      this.fileUploaded = false;
    },
    uploadFile() {
      this.disabledBtn = true;
      let formData = new FormData();
      formData.append("file", this.file);
      this.importExcelGenericProduct(formData).then(() => {});
      setTimeout(() => {
        this.removeUploadFile();
        this.disabledBtn = false;
      }, 1000);
    },
    getData(startData) {
      let model = {
        deductionAndIncreaseId: this.genericProductModel.deductionAndIncreaseId,
        startData: startData,
      };
      this.getListGenericProduct(model).then((r) => {
        this.listGenericProduct = r.data;
        this.totalCount = r.total;
        this.showLoading = false;
      });
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.showLoading = true;
        this.$validator.reset();
        this.getData(0);
      } else {
        if (this.$refs.genericProduct) {
          this.$refs.genericProduct.clearSelection();
        }
      }
    },
  },
  components: {
    Treeselect,
    Loading,
  },
};
</script>
